import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import { QuestionnaireNoticesResponse } from "@/Common/Models/Questionnaires/QuestionnaireNoticesResponse";
import { QuestionnaireResult } from "@/Common/Models/Questionnaires/QuestionnaireResult";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { UserSettings } from "@/Globals/Models/UserSettings";

class NoticeBoardAction extends AsyncAction {
    public async loadQuestionnairesForNoticeBoard(
        searchText: string,
        onlySelectedSiteIds: string[],
        employeeIds: string[],
        results: QuestionnaireResult[],
        isContactedPatientOnly: boolean,
        pageNumber: number = 1,
        pageSize: number = 50
    ): Promise<QuestionnaireNoticesResponse> {
        return this.postAsync<QuestionnaireNoticesResponse>(ServerOperations.Server.Myle_Questionnaire_GetQuestionnaireNotices, {
            SearchText: searchText,
            SiteIds: onlySelectedSiteIds,
            EmployeeIds: employeeIds,
            Results: results,
            IsContactedPatientOnly: isContactedPatientOnly,
            PageNumber: pageNumber,
            PageSize: pageSize
        });
    }

    public async updateQuestionnairePatientContacted(questionnaireInstanceId: string, contactedDate: Date): Promise<void> {
        await this.postAsync<null>(ServerOperations.Server.Myle_Questionnaire_UpdateQuestionnairePatientContactedDate, {
            QuestionnaireInstanceId: questionnaireInstanceId,
            ContactedDate: contactedDate
        });
    }

    public async saveSearchSettings(userSettings: UserSettings): Promise<void> {
        await this.postAsync<null>(ServerOperations.Server.Myle_UpdateUserSettings, {
            UserSettings: userSettings,
            UserId: sessionStore.userId
        });
    }
}

export { NoticeBoardAction };
